import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';
import { isObservable } from 'rxjs';
import { PRODUCTIONCOUNTRY } from '../../interfaces/production-country';
@Component({
    selector: 'app-filter-scenes',
    templateUrl: './filter-scenes.component.html',
    styleUrls: ['./filter-scenes.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterScenesComponent implements OnInit {

	@Input('viewData') $viewData: any;
	@Input() filterArguments: any;
	@Input() project: any = null;

	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	loading: boolean = false;
	viewFilterArguments: any;
	viewData: any;
	filteredSets: any = [];
	filteredElements: any = [];
	readonly PRODUCTIONCOUNTRY = PRODUCTIONCOUNTRY;
	listOfCharacters: any = [];

	getCharacters() {
		const charactersInLocal = JSON.parse(localStorage.getItem('Scnenefilter'))?.characters || [];
		const charactersWithInclude = this.viewData.characters_list.map(character => {
			const localCharacter = charactersInLocal.find(ch => ch.id === character.id);
			return {
			...character,
			include: localCharacter ? localCharacter.include : true
			};
		});
		return charactersWithInclude;
	}

	filter() {
		this.notify.emit(this.viewFilterArguments);
	}
	filterSets() {
		this.filteredSets = this.viewData.location_sets;
		this.filteredSets = this._fS.ElementInListElements(this.filteredSets, 'location_id', this.viewFilterArguments.locations, 'id')
		this.viewFilterArguments.sets = this._fS.ElementInListElements(this.viewFilterArguments.sets, 'location_id', this.viewFilterArguments.locations, 'id')
	}
	filterElements() {
		this.filteredElements = this.viewData.elements;
		this.filteredElements = this._fS.ElementInListElements(this.filteredElements, 'element_category_id', this.viewFilterArguments.element_categories, 'id')
		this.viewFilterArguments.elements = this._fS.ElementInListElements(this.viewFilterArguments.elements, 'element_category_id', this.viewFilterArguments.element_categories, 'id')
	}
	close() {
		event.stopPropagation();
		this.closeView.emit();
	}

	initValues(data: any) {
		console.log(this.filterArguments);
		this.viewData = data;
		// 5
		this.viewData.characters_list = this.viewData.characters.filter(ae => ae.character_role_id != 5);
		this.viewData.extras_list = this.viewData.characters.filter(ae => ae.character_role_id == 5);
		this.viewFilterArguments = Object.assign({}, this.filterArguments);
		this.filterSets();
		this.filterElements();
		this.loading = false;
		this.listOfCharacters = this.getCharacters();
	}

	constructor(public _gS: GlobalService, private _fS: FilterService) { }

	ngOnInit() {
		this.loading = true;

		if (isObservable(this.$viewData)) {
			this.$viewData.subscribe(viewData => {
				this.initValues(viewData);
			});
		} else {
			this.initValues(this.$viewData);
		}


	}

}
